import type { AdminUserSession } from '@ferty9/types';
import { hasAdminAppAccess as sharedHasAdminAppAccess, hasReportingPortalAccess } from '@ferty9/auth';

export function hasAdminAppAccess(user: AdminUserSession['user'] | null | undefined): boolean {
  return sharedHasAdminAppAccess(user);
}

export function hasAdminDashboardAccess(user: AdminUserSession['user'] | null | undefined): boolean {
  return sharedHasAdminAppAccess(user) || hasReportingPortalAccess(user);
}
